import React from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { IconButton } from '@osmosis/react-ui/components/IconButton';
import { Tooltip } from '@osmosis/tailwind-ui/components/tooltip/Tooltip';
import { faFlag } from '@fortawesome/pro-regular-svg-icons/faFlag';
import { faFlag as faFlagSolid } from '@fortawesome/pro-solid-svg-icons/faFlag';
import { useIntl } from 'react-intl';

type Props = {
  flagged: boolean;
  onClick: () => void;
};

/**
 * Button for flagging a flashcard.
 */
const FlagButton = (props: Props) => {
  const { flagged, onClick } = props;
  const intl = useIntl();

  return (
    <>
      <Tooltip
        id="flashcard-flag-btn"
        content={
          flagged
            ? intl.formatMessage({
                defaultMessage: 'Flagged for spaced repetition',
                id: 'flashcard.flagged_for_spaced_repetition',
              })
            : intl.formatMessage({
                defaultMessage: 'Flag as priority for spaced repetition',
                id: 'flashcard.flag_as_priority',
              })
        }
      />

      <Box data-tooltip-id="flashcard-flag-btn">
        <IconButton
          onClick={onClick}
          data-testid="flashcard-flag-btn"
          variant="transparent"
          fontSize={16}
          color={flagged ? 'primary' : 'text'}
          icon={<Icon icon={flagged ? faFlagSolid : faFlag} />}
        />
      </Box>
    </>
  );
};

export default FlagButton;
